<template>
    <div class="pages" v-if="pageShow">
        <div class="header">
            <div class="header-title flex items-center gap-[8px] cursor-pointer" @click="goBack"> <el-icon class="icon"
                    size="24">
                    <back />
                </el-icon> 智能场景匹配</div>
            <div class="btn" v-if="roleOptions == 9 && certificationOptions.audit_status == -1">
                <!-- {{ certificationOptions.audit_status }} -->
                <el-button type="primary" @click="showMerchantDialog = true">入驻商家</el-button>
                <el-button type="primary" @click="showDesignerDialog = true">成为设计师</el-button>

            </div>
            <div class="btn"
                v-if="(roleOptions == 9 || roleOptions == 4 || roleOptions == 8) && certificationOptions.audit_status == 0">
                <el-button type="warning">{{ certificationOptions.user_type == 1 ? '商家' : '设计师' }}审核......</el-button>
            </div>
            <div v-if="roleOptions == 8 && certificationOptions.audit_status == 1">
                <el-button type="primary" @click="showMerchantDialog = true">已认证商家</el-button>
            </div>
            <div v-if="roleOptions == 4 && certificationOptions.audit_status == 1">
                <el-button type="primary">已认证设计师</el-button>
            </div>
            <div v-if="roleOptions == 9 && certificationOptions.audit_status == 2">
                <el-button type="danger" @click="showFailDialog = true">已认证{{ certificationOptions.user_type == 1 ?
                    '商家' : '设计师' }}认证未通过</el-button>
            </div>
        </div>
        <div class="content">
            <div class="left">
                <div class="panel-title"><el-icon class="icon">
                        <EditPen />
                    </el-icon> 请描述您的派对需求</div>
                <div class="form-item">
                    <div class="inputName input-card">
                        <el-input v-model="textarea2" resize="none" style="width: 100%" type="textarea" :rows="5"
                            placeholder="例如：想办一个森系风格的生日派对，预算2000左右，大概20人，希望有很多绿植和自然元素，氛围温馨浪漫..." />
                    </div>
                </div>
                <div class="form-item">
                    <div class="item-title"><el-icon class="icon">
                            <PictureFilled />
                        </el-icon> 上传灵感图片（可选，支持多张）</div>
                    <div class="inputName">
                        <el-upload ref="inspireUploadRef" class="uploader" drag :show-file-list="false" multiple
                            accept="image/*" :limit="9" :on-exceed="onInspireExceed"
                            :before-upload="beforeInspireUpload" :http-request="dummyUpload"
                            :on-success="onInspireSuccess">
                            <div class="upload-card">
                                <template v-if="inspireList.length === 0">
                                    <div class="upload-icon">
                                        <el-icon>
                                            <PictureFilled />
                                        </el-icon>
                                    </div>
                                    <div class="upload-text-main">点击选择图片</div>
                                    <div class="upload-text-sub">支持 JPG、PNG，最多 9 张</div>
                                </template>
                                <template v-else>
                                    <div class="upload-grid">
                                        <div v-for="(f, idx) in inspireList" :key="f.uid || idx" class="works-item">
                                            <img :src="f.url" class="works-img" />
                                            <div class="remove-btn" title="删除" @click.stop="removeInspire(idx)">
                                                <el-icon>
                                                    <Close />
                                                </el-icon>
                                            </div>
                                        </div>
                                        <div v-if="inspireList.length < 9" class="works-item" @click="onAddInspire">
                                            <el-icon>
                                                <PictureFilled />
                                            </el-icon>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </el-upload>
                    </div>
                </div>
                <div class="form-item">
                    <div class="item-title"><el-icon class="icon">
                            <Collection />
                        </el-icon> 场景类型</div>
                    <div class="inputName">
                        <!-- <el-cascader style="width: 100%;" v-model="sceneValue" placeholder="请选择场景类型"
                            :options="sceneOptions" :props="cascaderProps" class="full">
                            <template #default="{ node, data }">
                                <div class="custom-node">
                                    <span>{{ data.name }}</span>
                                    <span>{{ node.level }}</span>
                                </div>
                            </template>
                        </el-cascader> -->
                        <el-select v-model="sceneValue" placeholder="请选择预算" class="full">
                            <el-option v-for="item in sceneOptions" :key="item.value" :label="item.value"
                                :value="item.value" />
                        </el-select>
                    </div>
                </div>

                <div class="form-item">
                    <div class="item-title"><el-icon class="icon">
                            <Coin />
                        </el-icon> 预算范围</div>
                    <div class="inputName">
                        <el-select v-model="budgetValue" placeholder="请选择预算" class="full">
                            <el-option v-for="item in budgetOptions" :key="item.value" :label="item.value"
                                :value="item.value" />
                        </el-select>
                    </div>
                </div>
                <div class="form-item">
                    <div class="item-title"><el-icon class="icon">
                            <Brush />
                        </el-icon> 风格偏好</div>
                    <div class="inputName">
                        <el-select v-model="styleValue" multiple placeholder="请选择风格" class="full">
                            <el-option v-for="item in styleOptions" :key="item.value" :label="item.value"
                                :value="item.value" />
                        </el-select>
                    </div>
                </div>

                <div class="form-item">
                    <div class="item-title"><el-icon class="icon">
                            <Tickets />
                        </el-icon> 主题偏好</div>
                    <div class="inputName">
                        <el-select v-model="themeValue" multiple placeholder="请选择主题" class="full">
                            <el-option v-for="item in themeOptions" :key="item.value" :label="item.value"
                                :value="item.value" />
                        </el-select>
                    </div>
                </div>
                <div class="action-bar">
                    <el-button type="primary" class="gen-btn" @click="onGenDesign">智能生成设计</el-button>
                </div>
            </div>
            <div class="right">
                <div v-if="matchIng === 'none'" class="flex w-full items-center justify-center h-full flex-col">
                    <img src="../../assets/empty.png" alt="" class="w-[400px]">
                    <div class="loading-title">智能生成设计</div>
                    <div class="loading-subtitle">在左侧内容区输入你的创意吧</div>
                </div>
                <NewLoading v-if="matchIng === 'loading'">
                    <div class="loading-title">AI 正在分析您的需求...</div>
                    <div class="loading-subtitle">正在分析需求...</div>
                </NewLoading>
                <result v-show="matchIng === 'success'" :plan="planValue" :usertype="roleOptions">
                </result>

            </div>
        </div>
        <MerchantImageDialog v-model:visible="showMerchantDialog" :image-src="merchantImageSrc"
            :business-detail="BusinessDetail" />
        <DesignerApplyDialog v-model:visible="showDesignerDialog" />
        <el-dialog v-model="showFailDialog" title="认证失败原因" width="420px" align-center>
            <div style="padding:12px;word-break:break-all;white-space:pre-wrap;">{{ certificationOptions.remark ||
                '暂无失败原因' }}
            </div>
            <template #footer>
                <div style="display:flex;justify-content:flex-end;gap:10px;padding:0 8px;">
                    <el-button @click="showFailDialog = false">关闭</el-button>
                    <el-button type="primary" @click="openApplyDialog(certificationOptions.user_type)">{{
                        certificationOptions.user_type == 1 ?
                            '重新提交商家申请' : '重新提交设计师申请' }}</el-button>
                    <el-button type="primary" @click="openApplyDialog(certificationOptions.user_type == 1 ? 3 : 1)">{{
                        certificationOptions.user_type == 1 ?
                            '入驻设计师'
                            : '入驻设商家' }}</el-button>
                    <!-- <el-button type="primary" @click="handleApplyAgain">重新申请</el-button> -->
                    <!-- <el-button type="danger" @click="handleApplyAgain">联系客服</el-button> -->
                </div>
            </template>
        </el-dialog>
    </div>
</template>
<script lang="ts" setup>
import { ref, onMounted, reactive } from 'vue'
import { useRoute } from 'vue-router'
import { PictureFilled, Close, EditPen, Collection, Coin, Brush, Tickets } from '@element-plus/icons-vue'
import { ElMessage } from 'element-plus'
import { getMatchCategory, uploadImage, createMatch, checkRole, getBusinessApplyStatus, getBusinessDetail } from '@/api/match'
//@ts-ignore
import NewLoading from '@/components/loading/loadingComp.vue'
//@ts-ignore
import result from '@/views/match/result.vue'
//@ts-ignore
import MerchantImageDialog from './MerchantImageDialog.vue'
//@ts-ignore
import DesignerApplyDialog from './DesignerApplyDialog.vue'
const matchIng = ref('none')
const textarea2 = ref('')
const pageShow = ref(false)
onMounted(() => {
    if (route.query.token) {
        localStorage.setItem('matchToken', route.query.token as string)
        if (route.query.orderId) {
            window.location.replace('/match?orderId=' + route.query.orderId)
        } else {
            window.location.replace('/match')
        }

        // matchOrderId.value = route.query.token as string
    } else if (localStorage.getItem('matchToken')) {
        pageShow.value = true
    } else {
        ElMessage.error('请先登录')
    }
    // if (route.query.token) {
    //     loca
    //     pageShow.value = false
    // }

    getmatchCategoryOpt()
    getRoleOpt()
    getUserOpt()
})
const sceneValue = ref('')
const cascaderProps = { checkStrictly: true, label: 'name', value: 'id' }
const sceneOptions = ref([])
const budgetValue = ref('')
const budgetOptions = ref([])
const styleValue = ref([])
const styleOptions = ref([])
const themeValue = ref([])
const themeOptions = ref([])
const showMerchantDialog = ref(false)
const merchantImageSrc = ref('https://via.placeholder.com/760x520.png?text=%E5%95%86%E5%AE%B6%E5%85%A5%E9%A9%BB%E7%94%B3%E8%AF%B7')
const showDesignerDialog = ref(false)
const showFailDialog = ref(false)
const inspireUploadRef = ref()
const inspireList = ref<Array<{ url: string, name: string, uid?: string | number, raw: File }>>([])
const beforeInspireUpload = (file: File) => {
    const okType = (file.type && file.type.startsWith('image/')) || /\.(png|jpe?g|png|webp|gif|bmp|svg)$/i.test(file.name || '')
    if (!okType) { ElMessage.error('仅支持图片格式'); return false }
    if (inspireList.value.length >= 9) { ElMessage.warning('最多选择 9 张'); return false }
    return true
}
const dummyUpload = (option: any) => { setTimeout(() => { option.onSuccess({}, option.file) }, 300) }
const onInspireSuccess = (_: any, file: any) => {
    const raw: File = file?.raw || file
    if (!raw) return
    const uid = file?.uid || raw.name
    if (inspireList.value.find(f => f.uid === uid || f.name === raw.name)) return
    const url = file?.url || URL.createObjectURL(raw)
    inspireList.value.push({ url, name: raw.name, uid, raw })
}
const onInspireExceed = () => { ElMessage.warning('最多选择 9 张') }
const removeInspire = (idx: number) => {
    const it = inspireList.value[idx]
    if (!it) return
    try { if (it.url && String(it.url).startsWith('blob:')) URL.revokeObjectURL(it.url) } catch { }
    inspireList.value.splice(idx, 1)
}
const onAddInspire = () => {
    try {
        const input = inspireUploadRef.value?.$el?.querySelector('input[type=file]')
        input && input.click()
    } catch { }
}
const getmatchCategoryOpt = async () => {
    const res = await getMatchCategory({})
    //@ts-ignore
    if (res.data?.code === 200) {
        // sceneOptions.value = res.data.data.categories
        sceneOptions.value = res.data.data.sceneTypes as any
        budgetOptions.value = res.data.data.budgetLevels as any
        styleOptions.value = res.data.data.styles as any
        themeOptions.value = res.data.data.themes as any
    }


}
const matchOrderId = ref('')
const route = useRoute()
const planValue = ref({})
const onGenDesign = async () => {
    // if (textarea2.value == '') {
    //     ElMessage.error('请输入设计需求')
    //     return
    // }
    matchIng.value = 'loading'
    // console.log(inspireList.value)
    let uploadUrls: string[] = []
    for (var i = 0; i < inspireList.value.length; i++) {
        const formData = new FormData()
        formData.append('file', inspireList.value[i].raw)
        const res = await uploadImage(formData)

        uploadUrls.push(res.data.data.url)
    }
    console.log(uploadUrls)
    // const formData = new FormData()
    // formData.append('file', inspireList.value[0].raw)
    // const res = await uploadImage(formData)
    // console.log(res.data.data)
    // if (res.data?.code === 200) {
    //     loading.hide()
    //     ElMessage.success('上传成功')
    // } else {
    //     loading.hide()
    //     ElMessage.error(res.data?.msg || '上传失败')
    // }
    const orderId = String((route.query as any).match_order_id || (route.query as any).orderid || '')
    let params = {
        match_order_id: orderId,
        demand: textarea2.value,
        // cid: sceneValue.value.join(','),
        scene_type: sceneValue.value,
        budgetLevels: budgetValue.value,
        styles: styleValue.value.join(','),
        themes: themeValue.value.join(','),
        inspire: uploadUrls.join(',')
    }
    const res = await createMatch(params)
    if (res.data?.code === 200) {
        matchIng.value = 'success'
        planValue.value = res.data.data
        // matchOrderId.value = res.data.data.match_order_id
    } else {
        matchIng.value = 'none'
        ElMessage.error(res.data?.msg || '生成失败')
    }
}
const roleOptions = ref('')
const getRoleOpt = async () => {
    const res = await checkRole({})
    //@ts-ignore
    if (res.data?.code === 200) {
        roleOptions.value = res.data.data
    }
}
const certificationOptions = ref({})
const getUserOpt = async () => {
    const res = await getBusinessApplyStatus({ origin_type: 2 })
    //@ts-ignore
    if (res.data?.code === 200) {
        certificationOptions.value = res.data.data
        if ((certificationOptions.value as any).audit_status == 1) {
            getDetails()
        }
    }
}
const openApplyDialog = (val) => {
    showFailDialog.value = false
    if (val == 3) {
        showDesignerDialog.value = true
    } else {
        showMerchantDialog.value = true

    }
    // showApplyDialog.value = true
}
const goBack = () => {
    window.location.replace('/admin')
    // window.history.back()
}
const BusinessDetail = ref({})
const getDetails = async () => {
    const res = await getBusinessDetail({ origin_type: 2 })
    if (res.data?.code === 200) {
        BusinessDetail.value = res.data.data.apply_info
    }
}
</script>
<style lang="scss" scoped>
.pages {
    width: 100%;
    height: 100vh;

    .header {
        height: 64px;
        width: 100%;
        background: #fff;
        border-bottom: 1px solid #eef1f5;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 20px;
    }
}

.content {
    width: 100%;
    height: calc(100vh - 64px);
    display: flex;

    .left {
        width: 380px;
        border-right: 1px solid #eef1f5;
        height: 100%;
        box-sizing: border-box;
        padding: 16px 20px;
        background: #fff;
    }

    .right {
        flex: 1;
        width: 100%;
        height: 100%;
    }
}

.panel-title {
    font-size: 16px;
    font-weight: 600;
    color: #1f2328;
    margin-bottom: 12px;
}

.form-item {
    margin-bottom: 16px;
}

.item-title {
    font-size: 14px;
    color: #38393b;
    font-weight: 600;
    margin-bottom: 8px;
}

.panel-title .icon,
.item-title .icon {
    margin-right: 6px;
    color: #2a66ff;
}

.input-card {
    background: #f5f7fa;
    border: 1px solid #eef1f5;
    border-radius: 10px;
    padding: 12px;
}

.full {
    width: 100%;
}

.upload-card {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 6px;
    width: 100%;
    min-height: 120px;
    border-radius: 10px;
    background: #fafbfc;
    color: #8a8f99;
    padding: 8px;
}

.upload-grid {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
}

.upload-icon :deep(svg) {
    width: 28px;
    height: 28px;
    color: #2a66ff;
}

.upload-text-main {
    font-size: 14px;
    color: #38393b;
}

.upload-text-sub {
    font-size: 12px;
    color: #8a8f99;
}

.imglist {
    margin-top: 8px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
}

.works-item {
    position: relative;
    height: 80px;
    border: 1px dashed #cfd3dc;
    border-radius: 8px;
    background: #fafbfc;
    display: flex;
    align-items: center;
    justify-content: center;
}

.remove-btn {
    position: absolute;
    top: 6px;
    right: 6px;
    width: 20px;
    height: 20px;
    border-radius: 10px;
    background: rgba(0, 0, 0, 0.45);
    color: #fff;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.remove-btn :deep(svg) {
    width: 14px;
    height: 14px;
}

.works-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 8px;
}

:deep(.el-textarea__inner),
:deep(.el-input__wrapper) {
    border-radius: 8px;
}

:deep(.el-input__wrapper.is-focus),
:deep(.el-select .el-input__wrapper.is-focus),
:deep(.el-textarea__inner:focus) {
    border-color: #2a66ff !important;
    box-shadow: 0 0 0 1px rgba(42, 102, 255, 0.2);
}

.action-bar {
    margin-top: 8px;
}

.gen-btn {
    width: 100%;
    background-color: #2a66ff;
}

.loading-title {
    margin-top: 24px;
    font-size: 20px;
    font-weight: 700;
    color: #111827;
}

.loading-subtitle {
    margin-top: 6px;
    font-size: 16px;
    color: #6b7280;
}
</style>
<style>
.el-upload-dragger {
    padding: 0;
}
</style>
